import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { Observable, of } from 'rxjs';
import { ValidationKeys } from '../models/validation-keys';
import { ValidationsBuilderModel } from '../models';

export class NotSupportedCharactersBuilder {
	private validation: AsyncValidatorFn;
	private validationsMessages: string[] = [];

	public constructor(private columnName: string) {}

	public validate(): ValidationsBuilderModel | null {
		if (
			[WorkspaceDatabaseKeys.columns.holeNumber, WorkspaceDatabaseKeys.columns.sampleNumber].includes(
				this.columnName
			)
		) {
			this.validation = this.notSupportedCharactersValidation();
			this.validationsMessages.push(ValidationKeys.validationRules.notSupportedCharactersRule);

			return { validation: this.validation, messages: this.validationsMessages };
		}

		return null;
	}

	public notSupportedCharactersValidation(): AsyncValidatorFn {
		return (control: AbstractControl): Observable<ValidationErrors | null> => {
			if (control?.value) {
				if (/['",;~@#]/.test(control.value)) {
					return of({ [ValidationKeys.validationRules.notSupportedCharactersRule]: true });
				}

				return of(null);
			}
			return of(null);
		};
	}
}
